import moment from 'moment';
import * as M from 'shared/types/models';

const DAYS_OF_WEEK = 7;

export function isFullWeek({ firstWeekDay, lastWeekDay }: M.CalendarWeek) {
  return moment(lastWeekDay).add(1, 'days').diff(firstWeekDay, 'days') === DAYS_OF_WEEK;
}
